import formUtils from '@/lib/formUtils/form-utils'
import formatUtils from '@/lib/formatUtils/format'
import format from '@/lib/formatUtils/format'
import { computed, SetupContext } from '@vue/composition-api'
import { defineObject } from '@/lib/define/use-define'
import { validNumber, validHalfSize } from '../validation/use-validation'
import sessionStorageUtils from '@/lib/sessionStrage/session-strage-utils'
import { OfficeInfo } from '@/@types/office'
import moment from 'moment'
import { ReBillingCldInfoBasicStateType, BasicStateType } from '@/@types/children'
import {
  validOfficeArrayNumeric,
  validOfficeArrayPhoneNumber,
} from '@/lib/validation/use-validation'
import { SchooType } from '@/@types/school'

const autoInsertArray = ['firstName', 'lastName']

// 放デイ
const HOUDAY_AFFILIATION = defineObject.HOUDAY_AFFILIATION

// 児発
const JIHATSU_AFFILIATION = defineObject.JIHATSU_AFFILIATION

// 保訪
const HOHOU_AFFILIATION = defineObject.HOHOU_AFFILIATION

const affiliationArray = [HOUDAY_AFFILIATION, JIHATSU_AFFILIATION]

// const RESET_ADDITION_CHILD_VALUE_BY_HOHOU =
//   defineObject.RESET_ADDITION_CHILD_VALUE_BY_HOHOU
// const RESET_ADDITION_VALUE_BY_HOHOU = defineObject.RESET_ADDITION_VALUE_BY_HOHOU
const RESET_VALUE_BY_HOHOU = defineObject.RESET_VALUE_BY_HOHOU
const RESET_VALUE_BY_TUSYO = defineObject.RESET_VALUE_BY_TUSYO
const DISCRIMINATION_AFFILIATION = defineObject.DISCRIMINATION_AFFILIATION
const CONTRACT_AND_START_USING_DATE = defineObject.CONTRACT_AND_START_USING_DATE

export const childAdditionKeyArray = [...defineObject.CHILD_ADDITION_KEY_ARRAY]

export const childAllAdditionItemArray = affiliationArray.map(
  (affiliation: string) => {
    let tmpKeyArray = [
      ...[...defineObject.CHILD_ADDITION_KEY_ARRAY].map(
        (childAdditionkey: { [key: string]: string }) => childAdditionkey.key
      ),
    ]

    if (affiliation === JIHATSU_AFFILIATION) {
      const prefix = 'jihatsu'

      tmpKeyArray.push(`kasanUpperLimit`)

      tmpKeyArray = tmpKeyArray.filter(key => key !== 'kasanDayUpper')

      tmpKeyArray = tmpKeyArray.map(
        key => prefix + key.charAt(0).toUpperCase() + key.slice(1)
      )
    }

    return {
      affiliation: affiliation,
      keyArray: tmpKeyArray,
    }
  }
)

const handleResetDayOfTheWeek = () => {
  for (let index = 0; index < defineObject.WEEK_OPTION_ARRAY.length; index++) {
    const weekEle = document.getElementById(
      `week_0${index}`
    ) as HTMLInputElement

    if (weekEle) {
      weekEle.checked = false
    }
  }
}

export const handleIsOfficeAffiliationInAffiliation = (
  officeAffiliation: string[],
  childAffiliation: string
) => {
  if (childAffiliation === '') {
    return true
  }

  if (
    officeAffiliation.some(
      (affiliation: string) => childAffiliation === affiliation
    )
  ) {
    return true
  } else {
    return false
  }
}

export const handleResetKasanByNotTargetAffiliation = (state: any) => {
  const targetResetKasanAllKeyArray = childAllAdditionItemArray.filter(
    (obj: { [key: string]: string | string[] }) =>
      obj.affiliation !== state.childParam.dataObject.affiliation
  )

  // 該当しない所属の加算を初期化
  for (let index = 0; index < targetResetKasanAllKeyArray.length; index++) {
    const targetKeyArray = targetResetKasanAllKeyArray[index].keyArray

    targetKeyArray.forEach((key: string) => {
      state.childParam.dataObject[key] = '0'
    })
  }

  if (state.childParam.dataObject.affiliation === HOUDAY_AFFILIATION) {
    // 放デイを選択している場合、無償化、多子軽減初期化
    state.childParam.dataObject.freeOfChargeFlg = '0'
    state.childParam.dataObject.manyChildrenNo = '1'
  }

  // 児発・放デイのいずれか選択のみ、保訪の受給者証関係の値をリセット
  if (
    (state.childParam.dataObject.affiliation === '0' ||
      state.childParam.dataObject.affiliation === '1') &&
    state.childParam.dataObject.visitChildFlg === '0'
  ) {
    RESET_VALUE_BY_HOHOU.forEach(el => {
      state.childParam.dataObject[el.key] = el.value
    })
  }

  // 保訪のみ選択時、通所の受給者証関係の値をリセット
  if (
    state.childParam.dataObject.affiliation === '2' ||
    (state.childParam.dataObject.affiliation === '' &&
      state.childParam.dataObject.visitChildFlg === '1')
  ) {
    RESET_VALUE_BY_TUSYO.forEach(
      (el: {
        key: string
        value:
          | string
          | {
              [key: string]: string
            }
      }) => {
        state.childParam.dataObject[el.key] = el.value
      }
    )

    if (Array.isArray(state.attendanceArray)) {
      handleResetDayOfTheWeek()
      state.attendanceArray.splice(0, state.attendanceArray.length)
    }

    // 保育所等訪問支援のみの場合は重心、医療的ケアの判定フラグを一律OFFにする
    state.viewSevereChildFlg = '0'
    state.viewMedicalCareChildFlg = '0'
  }

  // 放デイ、児童発達、保育所等訪問未選択
  if (
    state.childParam.dataObject.affiliation === '' &&
    state.childParam.dataObject.visitChildFlg === '0'
  ) {
    const ALL_RESET_VALUE = RESET_VALUE_BY_TUSYO.concat(
      RESET_VALUE_BY_HOHOU as {
        key: string
        value:
          | string
          | {
              [key: string]: string
            }
      }[]
    )

    ALL_RESET_VALUE.forEach((el: any) => {
      state.childParam.dataObject[el.key] = el.value
    })

    if (Array.isArray(state.attendanceArray)) {
      handleResetDayOfTheWeek()
      state.attendanceArray.splice(0, state.attendanceArray.length)
    }

    //所属が未選択の場合、無償化、多子軽減初期化
    state.childParam.dataObject.freeOfChargeFlg = '0'
    state.childParam.dataObject.manyChildrenNo = '1'

    //所属が未選択の場合、医療的ケア、重心空文字化
    state.viewSevereChildFlg = ''
    state.viewMedicalCareChildFlg = ''
  }

  // 所属が児童発達以外の場合は未就学児フラグを初期化
  if (
    state.childParam.dataObject.affiliation !== '' &&
    state.childParam.dataObject.affiliation !== '1'
  ) {
    state.childParam.dataObject.jihatsuKasanPreschoolersFlg = '0'
  }

  // 所属に関係なく、上限管理加算を初期化する
  state.childParam.dataObject.kasanDayUpper = '0'
  state.childParam.dataObject.jihatsuKasanUpperLimit = '0'
  state.childParam.dataObject.visitKasanUpperLimit = '0'
}

export const handleGetIsSelectAffiliation = (state: any) => {
  const object = DISCRIMINATION_AFFILIATION

  if (!state.officeAffiliation || state.officeAffiliation.length === 0) {
    return object
  }

  const isJihastu = state.officeAffiliation.some(
    (value: string) => value === JIHATSU_AFFILIATION
  )

  const isHouday = state.officeAffiliation.some(
    (value: string) => value === HOUDAY_AFFILIATION
  )

  if (state.officeAffiliation.length === 1) {
    // 単機能型
    if (isJihastu) {
      state.childParam.dataObject.affiliation = JIHATSU_AFFILIATION
      state.childParam.dataObject.visitChildFlg = '0'
    } else if (isHouday) {
      state.childParam.dataObject.affiliation = HOUDAY_AFFILIATION
      state.childParam.dataObject.visitChildFlg = '0'
    }

    object[JIHATSU_AFFILIATION] = true
    object[HOUDAY_AFFILIATION] = true
  } else {
    // 多機能型
    if (
      !state.officeAffiliation.some(
        (value: string) =>
          value === String(state.childParam.dataObject.affiliation)
      )
    ) {
      state.childParam.dataObject.affiliation = ''
    }

    Object.keys(object).forEach((key: string) => {
      if (
        state.officeAffiliation.some((value: string) => value === String(key))
      ) {
        object[key] = false
      } else {
        object[key] = true
      }
    })
  }

  return object
}

export const handleGetIsSelectVisitChildFlg = (state: any) => {
  const isHohou = state.officeAffiliation.some(
    (value: string) => value === HOHOU_AFFILIATION
  )

  if (isHohou) {
    if (state.officeAffiliation.length === 1) {
      state.childParam.dataObject.affiliation = HOHOU_AFFILIATION
      state.childParam.dataObject.visitChildFlg = '1'
      return true
    } else {
      return false
    }
  } else {
    state.childParam.dataObject.visitChildFlg = '0'
    return true
  }
}

export const handleSetDateByAffiliation = (state: any, keyArray: string[]) => {
  // 所属選択時に利用開始日、契約開始日を本日の日付をセット
  const today = new Date()
  const formatToday = `${today.getFullYear()}/${(
    '0' +
    (today.getMonth() + 1)
  ).slice(-2)}/${('0' + today.getDate()).slice(-2)}`
  keyArray.forEach(key => {
    if (state.childParam.dataObject[key] === '') {
      state.childParam.dataObject[key] = formatToday
    }
  })
}

export const handleResetValueByAffiliation = (state: any) => {
  handleResetKasanByNotTargetAffiliation(state)
}

export const handleUpperSelectValueSet = (
  index: number,
  state: any,
  context: any
) => {
  state.isOwnUpper = false
  state.contractDateFlg = false
  console.log(state.upperActive)

  // 上限管理変更時に上限管理のエラーオブジェクトを初期化
  const targetErrKeyArray = [
    // 上限管理
    'upperOfficeNumber',
    'upperOfficeTel',
    'upperOfficeFax',
    // 上限管理が自社の場合の他事業所
    'officeArrayOfficeTel',
    'officeArrayOfficeFax',
    'officeArrayOfficeNumber',
  ]

  Object.keys(state.upperLimit).forEach((key: string) => {
    state.upperLimit[key] = ''
  })

  state.officeArray.splice(-state.officeArray.length)

  for (let index = 0; index < targetErrKeyArray.length; index++) {
    if (state.errorList[targetErrKeyArray[index]]) {
      delete state.errorList[targetErrKeyArray[index]]
    }
  }

  const upperOwnNode = document.getElementById(
    'upper_active_00'
  ) as HTMLInputElement
  const upperOtherNode = document.getElementById(
    'upper_active_01'
  ) as HTMLInputElement

  const isOwnResult = upperOwnNode.checked as boolean
  const isOtherResult = upperOtherNode.checked as boolean

  if (!isOwnResult && !isOtherResult) {
    state.isAppear = true
    state.isOther = true
    state.isOwnUpper = false
    state.upperActive = []
  } else {
    const selectElement = document.getElementById(
      `upper_active_0${index}`
    ) as HTMLInputElement

    if (selectElement === null) return

    if (index === 0) {
      if (selectElement.checked === true) {
        state.isAppear = false
        state.isOther = false
        upperOtherNode.checked = false
        state.upperActive = ['0']

        state.officeArray.push({
          officeName: '',
          officeNumber: '',
          officeTel: '',
          officeFax: '',
          contractDate: '',
          contractEndDate: '',
          contractAmount: '',
          columnNumber: '',
        })

        state.isOwnUpper = true
      }
    } else {
      if (selectElement.checked === true) {
        state.isAppear = false
        state.isOther = true
        upperOwnNode.checked = false

        state.upperActive = ['1']

        state.isOwnUpper = false
      }
    }
  }

  context.root.$nextTick(() => {
    state.contractDateFlg = true
  })
}

export const handleUpperLimitReset = (
  state: any,
  context: SetupContext,
  // 受給者証番号なしを選択した場合のモード
  isNobeneficiaryIdFlgMode = false
) => {
  const upperOwnNode = document.getElementById(
    'upper_active_00'
  ) as HTMLInputElement
  const upperOtherNode = document.getElementById(
    'upper_active_01'
  ) as HTMLInputElement

  upperOwnNode.checked = false
  upperOtherNode.checked = false

  for (let index = 0; index < defineObject.UPPER_LIMIT_ARRAY.length; index++) {
    handleUpperSelectValueSet(index, state, context)
  }

  if (isNobeneficiaryIdFlgMode) {
    state.childParam.dataObject.lineId = ''
    state.childParam.dataObject.lineBlockFlg = 1
  }
}

export const handleSelectedAffiliation = (state: any, context: any) => {
  // 保訪がON、所属が空の場合に所属を２
  if (
    state.childParam.dataObject.affiliation === '' &&
    state.childParam.dataObject.visitChildFlg === '1'
  ) {
    state.childParam.dataObject.affiliation = '2'
  }

  const houday = document.getElementById(
    `affiliation_${HOUDAY_AFFILIATION}`
  ) as HTMLInputElement

  const jihatsu = document.getElementById(
    `affiliation_${JIHATSU_AFFILIATION}`
  ) as HTMLInputElement

  switch (state.childParam.dataObject.affiliation) {
    case '1':
      context.root.$nextTick(() => {
        jihatsu.checked = true
        houday.checked = false
      })
      break

    case '0':
      context.root.$nextTick(() => {
        houday.checked = true
        jihatsu.checked = false
      })
      break

    default:
      context.root.$nextTick(() => {
        jihatsu.checked = false
        houday.checked = false
      })
      break
  }

  if (
    state.childParam.dataObject.affiliation === '' &&
    state.childParam.dataObject.visitChildFlg === '0'
  ) {
    handleUpperLimitReset(state, context)
  }
}

export const handleChangeSetAffiliation = (
  state: any,
  key: string,
  inputValue: string,
  context: any
) => {
  const prevValue = JSON.parse(
    JSON.stringify(
      state.childParam.dataObject[key] ? state.childParam.dataObject[key] : ''
    )
  )

  // 児童発達、放デイの所属を追加するとき
  if (
    ((state.childParam.dataObject.affiliation === '' &&
      state.childParam.dataObject.visitChildFlg === '1') ||
      state.childParam.dataObject.affiliation === '2') &&
    state.childParam.dataObject.schoolYear &&
    (inputValue === '1' || inputValue === '0')
  ) {
    const schoolYearValue = defineObject.AGE_AND_SCHOOL_OPTION_ARRAY.find(
      (option: { [key: string]: string }) =>
        option.value === state.childParam.dataObject.schoolYear
    )

    if (schoolYearValue && schoolYearValue.affiliation !== inputValue) {
      const res = confirm(
        '所属を変更されますと学年・年齢が初期化されますがよろしいですか？'
      )
      if (res) {
        state.childParam.dataObject.schoolYear = ''
        state.childParam.dataObject.schoolId = ''
        state.childParam.dataObject.teacherName = ''

        state.childParam.dataObject[key] = inputValue
      } else {
        state.childParam.dataObject[key] = prevValue
        handleSelectedAffiliation(state, context)
        return
      }
    }
  }

  let res = false
  let schoolYearDiff = true

  if (prevValue !== '' && prevValue !== '2') {
    let affiliationTypeMsg = '放課後等デイサービス'

    if (prevValue === '1') {
      affiliationTypeMsg = '児童発達支援'
    }

    let defaultMsg = `所属を変更されますと${
      state.childParam.dataObject.schoolYear ? '学年・年齢、' : ''
    }加算項目および${affiliationTypeMsg}の受給者証情報等が初期化されますがよろしいですか？`

    if (state.childParam.dataObject.visitChildFlg === '1') {
      const schoolYearValue = defineObject.AGE_AND_SCHOOL_OPTION_ARRAY.find(
        (option: { [key: string]: string }) =>
          option.value === state.childParam.dataObject.schoolYear
      )

      if (schoolYearValue && schoolYearValue.affiliation === inputValue) {
        defaultMsg = `所属を変更されますと加算項目および${affiliationTypeMsg}の受給者証情報等が初期化されますがよろしいですか？`
        schoolYearDiff = false
      }
    }

    res = confirm(defaultMsg)
  }

  if (res) {
    if (schoolYearDiff && state.childParam.dataObject.schoolYear) {
      state.childParam.dataObject.schoolYear = ''
    }

    state.childParam.dataObject.schoolId = ''
    state.childParam.dataObject.teacherName = ''

    if (prevValue === inputValue) {
      state.childParam.dataObject[key] = ''
    } else {
      state.childParam.dataObject[key] = inputValue
    }

    handleResetValueByAffiliation(state)
  } else {
    if (prevValue !== '' && prevValue !== '2') {
      state.childParam.dataObject[key] = prevValue
    } else {
      state.childParam.dataObject[key] = inputValue
    }
  }

  handleSelectedAffiliation(state, context)
}

export const handleChangeSetHohouAffiliation = (
  state: any,
  key: string,
  inputValue: string,
  context: any
) => {
  const prevValue = JSON.parse(
    JSON.stringify(
      state.childParam.dataObject[key] ? state.childParam.dataObject[key] : '0'
    )
  )

  let res = false

  let defaultMsg = `所属を変更されますと${
    state.childParam.dataObject.schoolYear ? '学年・年齢、' : ''
  }加算項目および受給者証情報等が初期化されますがよろしいですか？`

  if (inputValue === '0') {
    if (
      state.childParam.dataObject.affiliation === '1' ||
      state.childParam.dataObject.affiliation === '0'
    ) {
      defaultMsg =
        '所属を変更されますと保育所等訪問の受給者証情報等が初期化されますがよろしいですか？'
    }

    res = confirm(defaultMsg)
  }

  if (res) {
    state.childParam.dataObject[key] = inputValue

    if (
      inputValue === '0' &&
      state.childParam.dataObject.schoolYear &&
      !(
        state.childParam.dataObject.affiliation === '1' ||
        state.childParam.dataObject.affiliation === '0'
      )
    ) {
      state.childParam.dataObject.schoolYear = ''
    }

    handleResetValueByAffiliation(state)
  } else {
    if (inputValue !== '0') {
      state.childParam.dataObject[key] = inputValue
    } else {
      state.childParam.dataObject[key] = prevValue
    }
  }

  const hohou = document.getElementById('visitChildFlg') as any

  // 保訪がON、所属が空の場合に所属を２
  if (
    state.childParam.dataObject.affiliation === '' &&
    state.childParam.dataObject.visitChildFlg === '1'
  ) {
    state.childParam.dataObject.affiliation = '2'
  } else if (
    state.childParam.dataObject.affiliation === '2' &&
    state.childParam.dataObject.visitChildFlg === '0'
  ) {
    state.childParam.dataObject.affiliation = ''
  }

  switch (state.childParam.dataObject[key]) {
    case '1':
      context.root.$nextTick(() => {
        hohou.checked = true
      })
      break

    default:
      context.root.$nextTick(() => {
        hohou.checked = false
      })
      break
  }

  if (
    state.childParam.dataObject.affiliation === '' &&
    state.childParam.dataObject.visitChildFlg === '0'
  ) {
    handleUpperLimitReset(state, context)
  }
}

export const handleSetMappingResponseChildData = (
  state: any,
  responseChildData: any
) => {
  if (!state.childParam.dataObject['basicSurvey']) {
    state.childParam.dataObject['basicSurvey'] = {}
  }

  for (let index = 0; index < state.componentTypes.length; index++) {
    if (
      state.componentTypes[index].tag != 'none' &&
      !responseChildData.basicSurvey
    ) {
      state.childParam.dataObject.basicSurvey[
        state.componentTypes[index].targetObjName
      ] = {}
    } else if (
      state.componentTypes[index].tag != 'none' &&
      responseChildData.basicSurvey
    ) {
      state.childParam.dataObject.basicSurvey[
        state.componentTypes[index].targetObjName
      ] =
        responseChildData.basicSurvey[state.componentTypes[index].targetObjName]
    }
  }

  // // 氏名(姓)/氏名(名)/氏名(姓)カナ/氏名(名)カナ/保護者(姓)/保護者(名)/保護者(姓)カナ/保護者(名)カナ/受給者証番号/契約支給量
  for (let index = 0; index < state.mappingKeyArray.length; index++) {
    const targetKey = state.mappingKeyArray[index]

    const targetSnakeKey = targetKey
      .split(/(?=[A-Z])/)
      .join('_')
      .toLowerCase()

    if (targetKey.includes('Kana') && responseChildData[targetSnakeKey]) {
      state.childParam.dataObject.basicSurvey['basicSurvey1'][
        targetKey
      ] = formUtils.handleKanaToHira(responseChildData[targetSnakeKey])
    } else if (
      responseChildData[targetSnakeKey] !== null &&
      responseChildData[targetSnakeKey] !== undefined
    ) {
      if (autoInsertArray.includes(targetKey)) {
        state.componentTypes.forEach((ele: { [key: string]: string }) => {
          if (state.childParam.dataObject.basicSurvey[ele.targetObjName])
            state.childParam.dataObject.basicSurvey[ele.targetObjName][
              targetKey
            ] = responseChildData[targetSnakeKey]
        })
      }

      state.childParam.dataObject.basicSurvey['basicSurvey1'][targetKey] =
        responseChildData[targetSnakeKey]
    }

    if (state.officeName !== null && state.officeName !== undefined) {
      state.childParam.dataObject.basicSurvey['basicSurvey1']['officeName'] =
        state.officeName
    }
  }
}

export const handleSetMappingPostChildData = (
  state: any,
  postChildData: any
) => {
  if (!state.childParam.dataObject['basicSurvey']) {
    state.childParam.dataObject['basicSurvey'] = {}
  }

  for (let index = 0; index < state.componentTypes.length; index++) {
    if (
      state.componentTypes[index].tag != 'none' &&
      !state.childParam.dataObject.basicSurvey[
        state.componentTypes[index].targetObjName
      ]
    ) {
      state.childParam.dataObject.basicSurvey[
        state.componentTypes[index].targetObjName
      ] = {}
    }
  }

  // // 氏名(姓)/氏名(名)/氏名(姓)カナ/氏名(名)カナ/保護者(姓)/保護者(名)/保護者(姓)カナ/保護者(名)カナ/受給者証番号/契約支給量
  for (let index = 0; index < state.mappingKeyArray.length; index++) {
    const targetKey = state.mappingKeyArray[index]

    if (targetKey.includes('Kana') && postChildData[targetKey]) {
      state.childParam.dataObject.basicSurvey['basicSurvey1'][
        targetKey
      ] = formUtils.handleKanaToHira(postChildData[targetKey])
    } else if (
      postChildData[targetKey] !== null &&
      postChildData[targetKey] !== undefined
    ) {
      if (autoInsertArray.includes(targetKey)) {
        state.componentTypes.forEach((ele: { [key: string]: string }) => {
          if (state.childParam.dataObject.basicSurvey[ele.targetObjName])
            state.childParam.dataObject.basicSurvey[ele.targetObjName][
              targetKey
            ] = postChildData[targetKey]
        })
      }

      state.childParam.dataObject.basicSurvey['basicSurvey1'][targetKey] =
        postChildData[targetKey]
    }

    if (state.officeName !== null && state.officeName !== undefined) {
      state.childParam.dataObject.basicSurvey['basicSurvey1']['officeName'] =
        state.officeName
    }
  }
}

export const handleSetContractAndStartUsingDate = (state: any) => {
  // 本日の日付を利用開始日に
  const today = new Date()

  const formatToday = `${today.getFullYear()}/${(
    '0' +
    (today.getMonth() + 1)
  ).slice(-2)}/${('0' + today.getDate()).slice(-2)}`

  CONTRACT_AND_START_USING_DATE.forEach((el: string) => {
    if (state.childParam.dataObject[el] === '') {
      state.childParam.dataObject[el] = formatToday
    }
  })
}

export const handleInputDateValueSet = (
  value: Date,
  key: string,
  parentKey: string,
  state: any
) => {
  let shapeDate = ''

  if (value) {
    shapeDate = `${value.getFullYear()}/${('0' + (value.getMonth() + 1)).slice(
      -2
    )}/${('0' + value.getDate()).slice(-2)}`
  }

  if (parentKey && parentKey === 'upperLimit') {
    state.upperLimit[key] = shapeDate
  } else if (parentKey && parentKey === 'officeArray') {
    const keyArray = key.split('_')
    state.officeArray[Number(keyArray[1])][keyArray[0]] = shapeDate
  } else {
    state.childParam.dataObject[key] = shapeDate
  }
}

export const childSnakeKeyFormat = (cldArray: any[]) => {
  const shapeCldArray = cldArray.map((cldObj: any) => {
    const snakeCldObj: any = {}

    Object.keys(cldObj).forEach((key: string) => {
      const snakeKey = formatUtils.snakeCase(key)
      snakeCldObj[snakeKey] = cldObj[key]
    })

    return snakeCldObj
  })

  return shapeCldArray
}

export const handlePostDataValid = (
  state: any,
  context: SetupContext,
  isReBilling = false,
  isCsvReBilling = false
): boolean => {
  try {
    // 受給者証番号を文字列化
    state.childParam.dataObject.beneficiaryId = String(
      state.childParam.dataObject.beneficiaryId
    )

    // 所属に該当しない加算、契約情報等を初期化
    handleResetKasanByNotTargetAffiliation(state)

    // 上限管理をdataObjectへ
    state.childParam.dataObject.upperLimit['0'] = {}
    state.childParam.dataObject.officeArray = {}

    const ownElement = document.getElementById(
      'upper_active_00'
    ) as HTMLInputElement
    const otherElement = document.getElementById(
      'upper_active_01'
    ) as HTMLInputElement
    let ownIsResult = ownElement.checked
    let otherIsResult = otherElement.checked

    const upperLimitAndOfficeKeyArray = Object.keys(state.upperLimit)
    const upperLimitAndOfficeEmptyAllowKeyArray = [
      'officeTel',
      'officeFax',
      'contractEndDate',
    ]

    if (
      state.childParam.dataObject.isNobeneficiaryIdFlg === '0' &&
      !validNumber(state.childParam.dataObject.beneficiaryId)
    ) {
      state.childParam.dataObject.isNobeneficiaryIdFlg = '1'
    }

    // 受給者証番号なしのフラグがONの場合は上限管理を初期化を確認する
    if (
      state.childParam.dataObject.isNobeneficiaryIdFlg === '1' &&
      (ownIsResult || otherIsResult)
    ) {
      const res = confirm(
        '受給者証番号がない場合はLINE ID,LINE設定,上限管理情報が初期化されますがよろしいですか？'
      )

      if (res) {
        handleUpperLimitReset(state, context, true)

        ownIsResult = false
        otherIsResult = false
      } else {
        throw new Error('バリデーションエラー')
      }
    }

    if (state.childParam.dataObject.isNobeneficiaryIdFlg === '1') {
      state.childParam.dataObject.lineId = ''
      state.childParam.dataObject.lineBlockFlg = 1
    }

    if (ownIsResult || otherIsResult) {
      if (isCsvReBilling) {
        upperLimitAndOfficeEmptyAllowKeyArray.push('officeName')

        if (otherIsResult) {
          // 他社用のバリデーションスルーkey
          upperLimitAndOfficeEmptyAllowKeyArray.push(
            ...['columnNumber', 'contractDate', 'contractAmount']
          )
        }
      }

      let isInput = true
      const isOwnIsResultAutoSetInput: string[] = []

      upperLimitAndOfficeKeyArray.forEach(key => {
        const snakeCase = format.snakeCase(key)
        let value = state.upperLimit[key]

        if (value === null || value === undefined) {
          value = ''
        }

        // 上限管理が自社の場合は、先に入力した契約開始日、事業所番号、事業所名、契約支給量等を自社の上限管理情報に自動セットするかつ、バリデーションチェックする
        if (ownIsResult && state.ownIsResultAutoSetKeyArray.includes(key)) {
          let affiliationType = ''

          if (state.childParam.dataObject.affiliation === '0') {
            affiliationType = '放課後等デイサービス'
          } else if (state.childParam.dataObject.affiliation === '1') {
            affiliationType = '児童発達支援'
          }

          switch (key) {
            case 'contractAmount':
              if (state.childParam.dataObject.affiliation === '2') {
                if (state.childParam.dataObject['visitContractAmount'] !== '') {
                  value = Number(
                    state.childParam.dataObject['visitContractAmount']
                  )
                } else {
                  isOwnIsResultAutoSetInput.push('保育所等訪問支援の契約支給量')
                }
              } else {
                if (state.childParam.dataObject[key] !== '') {
                  value = Number(state.childParam.dataObject[key])
                } else {
                  isOwnIsResultAutoSetInput.push(
                    `${affiliationType}の契約支給量`
                  )
                }
              }
              break

            case 'columnNumber':
              if (state.childParam.dataObject.affiliation === '2') {
                if (
                  state.childParam.dataObject[
                    'visitBeneficiaryEntryFieldNo'
                  ] !== ''
                ) {
                  value = Number(
                    state.childParam.dataObject['visitBeneficiaryEntryFieldNo']
                  )
                } else {
                  isOwnIsResultAutoSetInput.push(
                    '保育所等訪問支援の障害児通所支援事業者記入欄番号'
                  )
                }
              } else {
                if (
                  state.childParam.dataObject['beneficiaryEntryFieldNo'] !== ''
                ) {
                  value = Number(
                    state.childParam.dataObject['beneficiaryEntryFieldNo']
                  )
                } else {
                  isOwnIsResultAutoSetInput.push(
                    `${affiliationType}の障害児通所支援事業者記入欄番号`
                  )
                }
              }
              break

            case 'contractDate':
              if (state.childParam.dataObject.affiliation === '2') {
                if (state.childParam.dataObject['visitContractDate'] !== '') {
                  value = state.childParam.dataObject['visitContractDate']
                } else {
                  isOwnIsResultAutoSetInput.push('保育所等訪問支援の契約開始日')
                }
              } else {
                if (state.childParam.dataObject[key] !== '') {
                  value = state.childParam.dataObject[key]
                } else {
                  isOwnIsResultAutoSetInput.push(
                    `${affiliationType}の契約開始日`
                  )
                }
              }
              break

            case 'contractEndDate':
              if (state.childParam.dataObject.affiliation === '2') {
                if (
                  state.childParam.dataObject['visitContractEndDate'] !== ''
                ) {
                  value = state.childParam.dataObject['visitContractEndDate']
                }
              } else {
                if (state.childParam.dataObject[key] !== '') {
                  value = state.childParam.dataObject[key]
                }
              }
              break

            case 'officeNumber':
              if (state.officeNumber !== '') {
                state.upperLimit[key] = String(state.officeNumber)
                value = state.upperLimit[key]
              }
              break

            case 'officeName':
              if (state.officeName !== '') {
                state.upperLimit[key] = String(state.officeName)
                value = state.upperLimit[key]
              }
              break

            default:
              value = state.childParam.dataObject[key]
              break
          }

          if (isOwnIsResultAutoSetInput.length !== 0) {
            return
          }
        }

        if (
          !upperLimitAndOfficeEmptyAllowKeyArray.includes(key) &&
          value === ''
        ) {
          isInput = false
          return
        }

        if (key === 'columnNumber' || key === 'contractAmount') {
          state.childParam.dataObject.upperLimit['0'][snakeCase] = Number(value)
        } else if (key === 'officeNumber') {
          state.childParam.dataObject.upperLimit['0'][snakeCase] = String(value)
        } else {
          state.childParam.dataObject.upperLimit['0'][snakeCase] = value
        }
      })

      if (isOwnIsResultAutoSetInput.length !== 0) {
        const errMsg = isOwnIsResultAutoSetInput.join()
        alert(`${errMsg}を入力してください。`)
        throw new Error('バリデーションエラー')
      }

      if (!isInput) {
        alert('上限管理の必須項目で入力していない項目があります。')
        throw new Error('バリデーションエラー')
      }
    } else {
      // 上限管理未選択時の上限管理初期化
      state.childParam.dataObject.upperLimit = {}

      if (isReBilling) {
        // 上限管理が自社でない場合は作成区分初期化
        state.childParam.dataObject.creationCategory = ''
      }
    }

    let checkOfficeNumber = state.officeNumber

    if (state.officeUnitFlg === 1) {
      checkOfficeNumber = String(checkOfficeNumber).slice(0, -1)
    }

    checkOfficeNumber = ('0000000000' + checkOfficeNumber).slice(-10)

    if (ownIsResult) {
      if (isCsvReBilling) {
        // 他社用のバリデーションスルーkey（自社のバリデーション通過後）
        upperLimitAndOfficeEmptyAllowKeyArray.push(
          ...['columnNumber', 'contractDate', 'contractAmount']
        )
      }

      if (isReBilling && !state.childParam.dataObject.creationCategory) {
        alert('上限管理結果表の作成区分を選択してください。')
        throw new Error('バリデーションエラー')
      }

      let isInput = true
      console.log(state.officeArray)
      if (state.officeArray.length === 0) {
        alert('上限管理の他利用施設を1社以上入力してください。')
        throw new Error('バリデーションエラー')
      }

      if (state.officeArray.length !== 0) {
        state.officeArray.forEach((el: any, index: string) => {
          state.childParam.dataObject.officeArray[index] = {}

          upperLimitAndOfficeKeyArray.forEach(key => {
            const snakeCase = format.snakeCase(key)
            let value = state.officeArray[index][key] as any

            if (value === null || value === undefined) {
              value = ''
            }

            if (
              !upperLimitAndOfficeEmptyAllowKeyArray.includes(key) &&
              value === ''
            ) {
              isInput = false
              return
            }

            if (key === 'columnNumber' || key === 'contractAmount') {
              state.childParam.dataObject.officeArray[index][
                snakeCase
              ] = Number(value)
            } else if (key === 'officeNumber') {
              state.childParam.dataObject.officeArray[index][
                snakeCase
              ] = String(value)
            } else {
              state.childParam.dataObject.officeArray[index][snakeCase] = value
            }
          })
        })

        if (!isInput) {
          alert('上限管理の他利用施設で不足している項目があります。')
          throw new Error('バリデーションエラー')
        }

        if (
          state.officeArray.some(
            (otherOffice: any) => String(otherOffice.officeNumber).length < 10
          )
        ) {
          alert(
            '上限管理の他利用施設のうち、事業所番号が10桁未満のものが含まれています。'
          )
          throw new Error('バリデーションエラー')
        }

        const officeNumberArray = Object.keys(
          state.childParam.dataObject.officeArray
        ).map(
          (key: any) =>
            state.childParam.dataObject.officeArray[key].office_number
        )

        const ownerOfficeNumber = officeNumberArray.find(
          (number: any) => number === String(checkOfficeNumber)
        )

        if (ownerOfficeNumber) {
          isInput = false
        }

        if (!isInput) {
          alert('上限管理の他利用施設の事業所番号に自社が含まれています。')
          throw new Error('バリデーションエラー')
        }

        const extractOfficeNumberArray = new Set(officeNumberArray)

        if (extractOfficeNumberArray.size !== officeNumberArray.length) {
          alert('上限管理の他利用施設の事業所番号が重複しています。')
          throw new Error('バリデーションエラー')
        }
      }

      // 上限管理が自社の場合は上限管理加算を所属ごとに自動的にONにする
      switch (state.childParam.dataObject.affiliation) {
        case '0':
          state.childParam.dataObject.kasanDayUpper = '1'
          break

        case '1':
          state.childParam.dataObject.jihatsuKasanUpperLimit = '1'
          break

        default:
          if (state.childParam.dataObject.affiliation === '2') {
            state.childParam.dataObject.visitKasanUpperLimit = '1'
          }
          break
      }
    }

    if (otherIsResult) {
      let isInput = true

      if (isReBilling) {
        // 上限管理が自社でない場合は作成区分初期化
        state.childParam.dataObject.creationCategory = ''
      }

      if (
        state.childParam.dataObject.upperLimit['0']['office_number'] ===
        String(checkOfficeNumber)
      ) {
        isInput = false
      }
      if (!isInput) {
        alert(
          '上限管理設定の他社の事業所番号が自社の事業所番号になっております。'
        )
        throw new Error('バリデーションエラー')
      }

      let isMinLength = true

      if (
        String(state.childParam.dataObject.upperLimit['0']['office_number'])
          .length < 10
      ) {
        isMinLength = false
      }

      if (!isMinLength) {
        alert('上限管理設定の他社の事業所番号が10桁未満です。')
        throw new Error('バリデーションエラー')
      }
    }

    // 所属が児童発達の場合は未就学児フラグを必須化
    if (
      state.childParam.dataObject.affiliation === '1' &&
      state.childParam.dataObject.active !== 2 &&
      state.childParam.dataObject.active !== 99 &&
      (state.childParam.dataObject.jihatsuKasanPreschoolersFlg === '' ||
        state.childParam.dataObject.jihatsuKasanPreschoolersFlg === null ||
        state.childParam.dataObject.jihatsuKasanPreschoolersFlg === undefined)
    ) {
      alert('未就学児区分を選択してください。')
      throw new Error('バリデーションエラー')
    }

    if (
      state.childParam.dataObject.active !== 2 &&
      state.childParam.dataObject.active !== 99 &&
      !(state.viewSevereChildFlg === '0' || state.viewSevereChildFlg === '1')
    ) {
      alert('重症心身障害児に該当するかどうか選択してください。')
      throw new Error('バリデーションエラー')
    } else if (state.viewSevereChildFlg === '0') {
      // 重心フラグの初期化
      state.childParam.dataObject.severeChildFlg = '0'
      state.childParam.dataObject.jihatsuKasanSeverelyDisabled = '0'
    } else if (state.viewSevereChildFlg === '1') {
      // 所属を選択しているかつ、重心に該当を選択していた場合
      // 重心フラグの初期化
      state.childParam.dataObject.severeChildFlg = '0'
      state.childParam.dataObject.jihatsuKasanSeverelyDisabled = '0'

      if (state.childParam.dataObject.affiliation === '0') {
        state.childParam.dataObject.severeChildFlg = '1'
      } else if (state.childParam.dataObject.affiliation === '1') {
        state.childParam.dataObject.jihatsuKasanSeverelyDisabled = '1'
      }
    }

    if (
      state.childParam.dataObject.active !== 2 &&
      state.childParam.dataObject.active !== 99 &&
      !(
        state.viewMedicalCareChildFlg === '0' ||
        state.viewMedicalCareChildFlg === '1' ||
        state.viewMedicalCareChildFlg === '2' ||
        state.viewMedicalCareChildFlg === '3'
      )
    ) {
      alert('医療的ケア児に該当するかどうか選択してください。')
      throw new Error('バリデーションエラー')
    } else if (state.viewMedicalCareChildFlg === '0') {
      // 医療的ケアフラグの初期化
      state.childParam.dataObject.medicalCareChildFlg = '0'
      state.childParam.dataObject.jihatsuMedicalCareChildFlg = '0'
    } else if (
      state.viewMedicalCareChildFlg === '1' ||
      state.viewMedicalCareChildFlg === '2' ||
      state.viewMedicalCareChildFlg === '3'
    ) {
      // 医療的ケアフラグを選択していた場合
      // 医療的ケアフラグの初期化
      state.childParam.dataObject.medicalCareChildFlg = '0'
      state.childParam.dataObject.jihatsuMedicalCareChildFlg = '0'

      if (state.childParam.dataObject.affiliation === '0') {
        state.childParam.dataObject.medicalCareChildFlg =
          state.viewMedicalCareChildFlg
      } else if (state.childParam.dataObject.affiliation === '1') {
        state.childParam.dataObject.jihatsuMedicalCareChildFlg =
          state.viewMedicalCareChildFlg
      }
    }

    return true
  } catch (error) {
    return false
  }
}

export const handleUnitOffice = (state: any) => {
  if (state.officeUnitFlg) {
    return true
  } else {
    return false
  }
}

export const useComputed = (state: any, context: SetupContext) => {
  const getIsSelectAffiliation = computed(() => {
    return handleGetIsSelectAffiliation(state)
  })

  const getIsSelectVisitChildFlg = computed(() => {
    return handleGetIsSelectVisitChildFlg(state)
  })

  const isNoBeneficiaryIdNoEmptyFlg = computed({
    get: () => {
      if (state.childParam.dataObject.isNobeneficiaryIdFlg === '0') {
        return false
      } else {
        return true
      }
    },
    set: (value: boolean) => {
      if (value) {
        state.childParam.dataObject.isNobeneficiaryIdFlg = '1'

        if (state.errorList.beneficiaryId) {
          delete state.errorList.beneficiaryId
        }

        handleUpperLimitReset(state, context, true)
      } else {
        state.childParam.dataObject.isNobeneficiaryIdFlg = '0'
      }

      if (
        validNumber(state.childParam.dataObject.beneficiaryId) ||
        (!validHalfSize(state.childParam.dataObject.beneficiaryId) &&
          state.childParam.dataObject.isNobeneficiaryIdFlg === '1')
      ) {
        state.childParam.dataObject.beneficiaryId = ''
      }

      if (state.isReBilling) {
        state.childParam.dataObject.beneficiaryId = ''
      }
    },
  })

  const isUnitOffice = computed(() => {
    return handleUnitOffice(state)
  })

  return {
    getIsSelectAffiliation,
    getIsSelectVisitChildFlg,
    isNoBeneficiaryIdNoEmptyFlg,
    isUnitOffice,
  }
}

export const handleIsbeneficiaryIdView = (beneficiaryId: string) => {
  if (validNumber(beneficiaryId)) {
    return true
  } else {
    return false
  }
}

export const useRooting = (context: SetupContext) => {
  const handleEditData = (cldId: string) => {
    context.root.$router.push({
      path: '/children/edit/',
    })

    const res = sessionStorageUtils.handleSetSessionStorage('cldId', cldId)
    if (!res) {
      alert(
        'データを正常に取得できませんでした。時間をおいて再度ご利用ください。'
      )
      return
    }
  }

  return {
    handleEditData,
  }
}

export const useUtils = (state: any) => {
  const handleSelectStaffId = (staffId: string, staffName: string) => {
    state.childParam.dataObject.lastUpdatedByStaffId = staffId
    state.childParam.dataObject.lastUpdatedByStaffName = staffName
  }

  return {
    handleSelectStaffId,
  }
}

export const handleIsAllowKasanNursingValue = (
  severeChildFlg: string,
  officeData: OfficeInfo
) => {
  let res = false

  if (
    severeChildFlg === '1' &&
    officeData &&
    (officeData.areaClassLevel === '2' || officeData.area_class_level === '2')
  ) {
    res = true
  }

  return res
}

export const handleIsKasanNursingKey = (checkKey: string) => {
  const regex = new RegExp('kasanNursing', 'gi')

  return regex.test(checkKey)
}

export const handleInitViewChildFlg = <
  T extends {
    viewSevereChildFlg: string
    viewMedicalCareChildFlg: string
  }
>(
  state: T,
  currentChildData: any
) => {
  const currentCamelChildData: any = {}

  Object.keys(currentChildData).forEach(childSnakeKey => {
    const camelKey = formatUtils.camelCase(childSnakeKey)

    currentCamelChildData[camelKey] = currentChildData[childSnakeKey]
  })

  const viewChildFlgKeyObjArray: {
    affiliation: string
    severeChildKey: string
    medicalCareChildKey: string
  }[] = [
    {
      affiliation: '0',
      severeChildKey: 'severeChildFlg',
      medicalCareChildKey: 'medicalCareChildFlg',
    },
    {
      affiliation: '1',
      severeChildKey: 'jihatsuKasanSeverelyDisabled',
      medicalCareChildKey: 'jihatsuMedicalCareChildFlg',
    },
  ]

  const targetViewChildFlgKeyObj = viewChildFlgKeyObjArray.find(
    (viewChildFlgKeyObj: {
      affiliation: string
      severeChildKey: string
      medicalCareChildKey: string
    }) => viewChildFlgKeyObj.affiliation === currentCamelChildData.affiliation
  )

  if (targetViewChildFlgKeyObj) {
    const severeChildKey = targetViewChildFlgKeyObj.severeChildKey

    const medicalCareChildKey = targetViewChildFlgKeyObj.medicalCareChildKey

    state.viewSevereChildFlg =
      currentCamelChildData[severeChildKey] !== undefined &&
      currentCamelChildData[severeChildKey] !== null
        ? String(currentCamelChildData[severeChildKey])
        : ''

    state.viewMedicalCareChildFlg =
      currentCamelChildData[medicalCareChildKey] !== undefined &&
      currentCamelChildData[medicalCareChildKey] !== null
        ? String(currentCamelChildData[medicalCareChildKey])
        : ''
  }
}

// useDataRelated
export const useChildrenReBillingDataRelated = (
  state: ReBillingCldInfoBasicStateType,
  validOfficeArrayPhoneNumber: Function,
  context: SetupContext
) => {
  const handleInitData = async (
    currentChildData: any,
    officeData: OfficeInfo | null = null
  ) => {
    let prevAffiliation = ''

    Object.keys(currentChildData).forEach(key => {
      const camelKey = formatUtils.camelCase(key)

      const value = currentChildData[key]
      if (
        value === null ||
        value === '' ||
        !Object.keys(state.childParam.dataObject).some(
          (paramKey: string) => paramKey === camelKey
        )
      )
        return

      if (camelKey === 'active') {
        state.prevActive = currentChildData[key]

        if (currentChildData[key] === 1) {
          state.activeArray = defineObject.ACTIVE_ARRAY.filter(
            ele => ele.value !== 2 && ele.value !== 99
          )
        } else if (currentChildData[key] === 0) {
          state.activeArray = defineObject.ACTIVE_ARRAY.filter(
            ele => ele.value !== 2
          )
        } else if (currentChildData[key] === 2) {
          state.activeArray = defineObject.ACTIVE_ARRAY.filter(
            ele => ele.value !== 0
          )
        } else if (currentChildData[key] === 99) {
          state.activeArray = defineObject.ACTIVE_ARRAY.filter(
            ele => ele.value === 99
          )
        }
      }

      if (camelKey === 'schoolId') {
        if (state.allSchoolArray && state.allSchoolArray.length !== 0) {
          let index = false
          state.allSchoolArray.forEach((el: any) => {
            if (el.id === value) {
              index = true
            }
          })
          if (!index) {
            state.childParam.dataObject.schoolId = ''
          } else {
            state.childParam.dataObject.schoolId = value
          }
        }
        return
      }

      if (camelKey === 'officeArray') {
        if (Object.keys(value).length === 0) return
        state.upperActive = ['0']
        state.isAppear = false
        state.isOther = false
        state.isOwnUpper = true

        const otherOfficeKeyArray = Object.keys(state.upperLimit)

        Object.keys(currentChildData[key]).forEach((el, index) => {
          otherOfficeKeyArray.forEach((deepCamelKey: string) => {
            if (!state.officeArray[index]) {
              state.officeArray[index] = {} as any
            }

            const snakeKey = format.snakeCase(deepCamelKey)

            const value = currentChildData[key][el][snakeKey]

            if (!value) {
              state.officeArray[index][deepCamelKey] = ''
              return
            }

            if (
              deepCamelKey === 'contractDate' ||
              deepCamelKey === 'contractEndDate'
            ) {
              if (value === '') return
              const formatDate = moment(value, 'YYYY/MM/DD').format(
                'YYYY/MM/DD'
              )
              if (formatDate === undefined) return
              state.officeArray[index][deepCamelKey] = formatDate
            } else {
              state.officeArray[index][deepCamelKey] = value
            }
          })
        })

        context.root.$set(
          state,
          'defaultOfficeArray',
          JSON.parse(JSON.stringify(state.officeArray))
        )
        return
      }

      if (camelKey === 'upperLimit') {
        if (Object.keys(value).length === 0) return

        Object.keys(currentChildData[key]['0']).forEach(deepKey => {
          const value = currentChildData[key]['0'][deepKey]
          const camelCase = format.camelCase(deepKey)
          if (value === undefined) return

          if (camelCase === 'contractDate' || camelCase === 'contractEndDate') {
            if (value === '') return
            const formatDate = moment(value, 'YYYY/MM/DD').format('YYYY/MM/DD')
            if (formatDate === undefined) return
            state.upperLimit[camelCase] = formatDate
          } else {
            state.upperLimit[camelCase] = value
          }
        })

        if (
          String(state.upperLimit.officeNumber) === String(state.officeNumber)
        ) {
          // 上限管理が自社
          state.upperActive = ['0']
          state.isAppear = false
          state.isOther = false
          state.isOwnUpper = true
        } else if (state.upperLimit.officeNumber !== '') {
          // 上限管理が他社
          state.upperActive = ['1']
          state.isAppear = false
          state.isOther = true
          state.isOwnUpper = false
        }

        context.root.$set(
          state,
          'defaultUpperLimit',
          JSON.parse(JSON.stringify(state.upperLimit))
        )
        return
      }

      if (
        camelKey === 'startUsingDate' ||
        camelKey === 'endUsingDate' ||
        camelKey === 'contractDate' ||
        camelKey === 'contractEndDate'
      ) {
        if (currentChildData[key] === '') return
        const formatDate = moment(value, 'YYYY/MM/DD').format('YYYY/MM/DD')
        if (formatDate === undefined) return

        state.childParam.dataObject[camelKey] = formatDate
        return
      }

      if (camelKey === 'zip') {
        state.childParam.dataObject[camelKey] =
          currentChildData[key] === 0 ? '' : currentChildData[key]
        return
      }

      if (camelKey === 'beneficiaryId') {
        if (!validNumber(currentChildData[key])) {
          state.childParam.dataObject.isNobeneficiaryIdFlg = '1'
        } else {
          state.childParam.dataObject.isNobeneficiaryIdFlg = '0'
        }
        state.childParam.dataObject[camelKey] = currentChildData[key]
        return
      }

      if (camelKey === 'affiliation') {
        prevAffiliation = currentChildData[key]
      }

      state.childParam.dataObject[camelKey] = currentChildData[key]
    })

    // 事業形態を元に所属を検証
    if (
      officeData &&
      !handleIsOfficeAffiliationInAffiliation(
        officeData.affiliation,
        prevAffiliation
      )
    ) {
      state.childParam.dataObject.schoolYear = ''
      state.childParam.dataObject.schoolId = ''
      state.childParam.dataObject.teacherName = ''
    }

    // 重心、医療的ケア児フラグセット用
    handleInitViewChildFlg(state, currentChildData)

    state.defaultChildData = JSON.parse(
      JSON.stringify(state.childParam.dataObject)
    )
  }

  const handleAddUpperLimit = () => {
    if (state.officeArray.length > 7) {
      state.isAddUpperLimit = true
      return
    }
    state.isAddUpperLimit = false
    state.officeArray.push({
      officeName: '',
      officeNumber: '',
      contractDate: '',
      contractEndDate: '',
      contractAmount: '',
      columnNumber: '',
      officeTel: '',
      officeFax: '',
    })
  }

  const handleDeleteArray = (index: number) => {
    if (state.officeArray.length <= 1) return

    state.officeArray.splice(index, 1)

    state.officeArrayContractDateFlg = false

    for (let index = 0; index < state.officeArray.length; index++) {
      Object.keys(state.officeArray[index]).forEach((key: string) => {
        if (
          key === 'officeTel' ||
          key === 'officeFax' ||
          key === 'officeNumber'
        ) {
          const upperKey = key.charAt(0).toUpperCase() + key.slice(1)

          validOfficeArrayPhoneNumber(
            state.officeArray[index][key],
            state.errorList,
            `officeArray${upperKey}`,
            index
          )

          validOfficeArrayPhoneNumber(
            '',
            state.errorList,
            `officeArray${upperKey}`,
            index + 1
          )
        }
      })
    }

    context.root.$nextTick(() => {
      state.officeArrayContractDateFlg = true
    })

    if (state.officeArray.length < 8) {
      state.isAddUpperLimit = false
    }
  }

  return {
    handleInitData,
    handleAddUpperLimit,
    handleDeleteArray,
  }
}

export const useChildrenReBillinSelectValue = (
  state: ReBillingCldInfoBasicStateType,
  context: SetupContext
) => {
  const handleAutoAddress = (value: any) => {
    if (value === null) return

    state.childParam.dataObject.prefecture =
      defineObject.PREFECTURE_OPTION_ARRAY[Number(value.prefcode)].value
    state.childParam.dataObject.city = `${value.ja.address1}${value.ja.address2}`
  }

  const handlePrefectureInput = (key: string, value: string) => {
    if (value === null) return
    state.childParam.dataObject.prefecture = value
  }

  const handleValueNumberInput = (
    key: string,
    event: Event,
    maxLength: null | number | string | undefined
  ) => {
    // Eventはinterfaceなのでvalueがない。
    // instanceofでHTMLInputElementをということを明示的にする
    if (!(event.target instanceof HTMLInputElement)) return

    if (event.target.value === '') return

    if (maxLength) {
      event.target.value = event.target.value.slice(0, Number(maxLength))
    }

    if (event.target.value.replace(/[^0-9]/g, '') === '') {
      state.childParam.dataObject[key] = ''
      return
    }

    state.childParam.dataObject[key] = Number(
      event.target.value.replace(/[^0-9]/g, '')
    )

    if (key === 'ubUpperLimitMonthlyAmount') {
      state.childParam.dataObject[key] = String(
        Number(event.target.value.replace(/[^0-9]/g, ''))
      )
    }
  }

  const handleValueNumberInputByUpperLimitValue = (
    key: string,
    event: Event,
    maxLength: null | number | string | undefined
  ) => {
    // Eventはinterfaceなのでvalueがない。
    // instanceofでHTMLInputElementをということを明示的にする
    if (!(event.target instanceof HTMLInputElement)) return

    if (event.target.value === '') return

    if (maxLength) {
      event.target.value = event.target.value.slice(0, Number(maxLength))
    }

    if (event.target.value.replace(/[^0-9]/g, '') === '') {
      state.upperLimit[key] = ''
      return
    }

    state.upperLimit[key] = Number(event.target.value.replace(/[^0-9]/g, ''))
  }

  const handleValueNumberInputByOfficeArrayValue = (
    index: number,
    setValue: any,
    key: string,
    event: Event,
    maxLength: null | number | string | undefined
  ) => {
    // Eventはinterfaceなのでvalueがない。
    // instanceofでHTMLInputElementをということを明示的にする
    if (!(event.target instanceof HTMLInputElement)) return

    if (event.target.value === '') return

    if (maxLength) {
      event.target.value = event.target.value.slice(0, Number(maxLength))
    }

    if (setValue) {
      if (event.target.value.replace(/[^0-9]/g, '') === '') {
        setValue[key] = ''
        return
      }

      setValue[key] = Number(event.target.value.replace(/[^0-9]/g, ''))
      state.officeArray.splice(index, 1, setValue)
    }
  }

  const valueStringInputbyOfficeArray = (
    setValue: string | null,
    errorList: any,
    errorKey: string,
    index: number
  ) => {
    if (setValue === null) return

    if (errorKey === 'officeArrayOfficeNumber') {
      validOfficeArrayNumeric(setValue, errorList, errorKey, index)
    } else if (
      errorKey === 'officeArrayOfficeTel' ||
      errorKey === 'officeArrayOfficeFax'
    ) {
      validOfficeArrayPhoneNumber(setValue, errorList, errorKey, index)
    }

    state.officeArray.splice(index, 1, state.officeArray[index])
  }

  const handleInputDateValueByOfficeArrayValue = (
    value: Date,
    key: string,
    parentKey: string
  ) => {
    handleInputDateValueSet(value, key, parentKey, state)
    const index = Number(key.split('_')[1])

    if (state.officeArray[index]) {
      state.officeArray.splice(index, 1, state.officeArray[index])
    }
  }

  const handleChangeAffiliation = (key: string, inputValue: string) => {
    handleChangeSetAffiliation(state, key, inputValue, context)
  }

  const handleChangeHohouAffiliation = (key: string, inputValue: string) => {
    handleChangeSetHohouAffiliation(state, key, inputValue, context)
  }

  const handleInputValue = (key: string, inputValue: string) => {
    state.childParam.dataObject[key] = inputValue
  }

  const handleInputViewChildFlg = (setKey: string, inputValue: string) => {
    switch (setKey) {
      case 'viewMedicalCareChildFlg':
      case 'viewSevereChildFlg':
        state[setKey] = String(inputValue)
        break
    }
  }

  const handleInputOtherValue = (inputValue: string) => {
    state.childParam.dataObject.otherZip = inputValue
  }

  const handleUpperSelect = (index: number) => {
    handleUpperSelectValueSet(index, state, context)
  }

  const handleInputDateValue = (
    value: Date,
    key: string,
    parentKey: string
  ) => {
    handleInputDateValueSet(value, key, parentKey, state)
  }

  const handleInputOnOffValue = (key: string, value: string) => {
    state.childParam.dataObject[key] = value
  }

  return {
    handleValueNumberInputByUpperLimitValue,
    handleValueNumberInputByOfficeArrayValue,
    valueStringInputbyOfficeArray,
    handleInputDateValueByOfficeArrayValue,
    handleValueNumberInput,
    handleInputValue,
    handleInputViewChildFlg,
    handleChangeAffiliation,
    handleChangeHohouAffiliation,
    handleInputOtherValue,
    handleUpperSelect,
    handleInputDateValue,
    handleInputOnOffValue,
    handleAutoAddress,
    handlePrefectureInput,
  }
}

export const useChildrenReBillinValid = () => {
  const handleValidCommingAndLeaving = (
    state: ReBillingCldInfoBasicStateType,
    isCsvReBilling = false
  ) => {
    const emptyArray = [] as []

    if (Object.keys(state.errorList).length !== 0) {
      alert('正しい形式で入力してください')
      return emptyArray
    }

    const validInputArray = [
      { name: 'active', text: '状態' },
      { name: 'lastName', text: '児童 姓' },
      { name: 'firstName', text: '児童 名' },
      { name: 'lastKana', text: '児童 セイ' },
      { name: 'firstKana', text: '児童 メイ' },
      { name: 'parentsLastName1', text: '保護者 姓' },
      { name: 'parentsFirstName1', text: '保護者 名' },
      { name: 'parentsLastKana1', text: '保護者 セイ' },
      { name: 'parentsFirstKana1', text: '保護者 メイ' },
      { name: 'beneficiaryId', text: '受給者番号' },
      { name: 'cityNumber', text: '市町村番号' },
      { name: 'ubUpperLimitMonthlyAmount', text: '利用者負担上限月額' },
    ]

    if (state.childParam.dataObject.affiliation !== '2') {
      validInputArray.push({ name: 'affiliation', text: '所属' })

      let affiliationType = ''

      switch (state.childParam.dataObject.affiliation) {
        case '1':
          affiliationType = '児童発達支援'
          break

        case '0':
          affiliationType = '放課後等デイサービス'
          break
      }

      if (state.childParam.dataObject.affiliation !== '') {
        validInputArray.push(
          ...[
            {
              name: 'contractAmount',
              text: `${affiliationType}の契約支給量`,
            },
            {
              name: 'startUsingDate',
              text: `${affiliationType}の契約開始年月日`,
            },
            {
              name: 'beneficiaryEntryFieldNo',
              text: `${affiliationType}の障害児通所支援事業者記入欄番号`,
            },
            {
              name: 'contractDate',
              text: `${affiliationType}の受給者証の決定期間の開始年月日`,
            },
          ]
        )

        if (!isCsvReBilling) {
          validInputArray.push({
            name: 'paymentAmount',
            text: `${affiliationType}の支給量等`,
          })
        }
      }
    }

    if (state.childParam.dataObject.visitChildFlg === '1') {
      validInputArray.push(
        ...[
          {
            name: 'visitContractAmount',
            text: '保育所等訪問支援の契約支給量',
          },
          {
            name: 'visitStartUsingDate',
            text: '保育所等訪問支援の契約開始年月日',
          },
          {
            name: 'visitBeneficiaryEntryFieldNo',
            text: '保育所等訪問支援の障害児通所支援事業者記入欄番号',
          },
          {
            name: 'visitContractDate',
            text: '保育所等訪問支援の受給者証の決定期間の開始年月日',
          },
        ]
      )

      if (!isCsvReBilling) {
        validInputArray.push({
          name: 'visitPaymentAmount',
          text: '保育所等訪問支援の支給量等',
        })
      }
    }

    if (!isCsvReBilling) {
      validInputArray.push({ name: 'schoolYear', text: '学年・年齢' })
    }

    validInputArray.forEach((key: { [key: string]: string }) => {
      if (key.name === 'beneficiaryId') {
        if (
          state.childParam.dataObject.isNobeneficiaryIdFlg === '0' &&
          (state.childParam.dataObject[key.name] === null ||
            state.childParam.dataObject[key.name] === '')
        ) {
          emptyArray.push(key.text as never)
        }
      } else {
        if (
          state.childParam.dataObject[key.name] === null ||
          state.childParam.dataObject[key.name] === ''
        ) {
          emptyArray.push(key.text as never)
        }
      }
    })

    if (emptyArray.length !== 0) {
      const message = emptyArray.join(',')
      alert(`${message}は必須項目です`)
    }

    return emptyArray
  }
  return {
    handleValidCommingAndLeaving,
  }
}

export const handleCrateChildSchoolArray = (schoolDataArray: SchooType[] = []) => {
  const schoolSelectArray = [
    { text: '選択してください', value: '', schoolType: '' },
  ]

  if (Array.isArray(schoolDataArray)) {
    schoolDataArray.forEach((schooldInfo: SchooType) => {
      schoolSelectArray.push({
        text: schooldInfo.school_name,
        value: schooldInfo.id,
        schoolType: schooldInfo.school_type,
      })
    })
  }

  return schoolSelectArray
}

export const handleGetSchoolTypeTargetKeyword = (
  schoolId: string,
  affiliation: string,
  schoolArray: { [key: string]: string }[]
) => {
  let targetKeyword = ''

  if (schoolId && Array.isArray(schoolArray) && affiliation === '0') {
    const targetSchoolInfo = schoolArray.find(
      schoolInfo => schoolInfo.value === schoolId
    )

    if (targetSchoolInfo) {
      const targetSchoolType = defineObject.SCHOOL_TYPE_ARRAY.find(
        schoolType => schoolType === targetSchoolInfo.schoolType
      )

      if (targetSchoolType) {
        targetKeyword = targetSchoolType.slice(0, 1)
      }
    }
  }

  return targetKeyword
}

export const handleSetDefaultTime = (
  state: BasicStateType,
  currentOfficeData: any,
  type: string //start or end
) => {
  console.log(state.childParam.dataObject)
  let [hour, minute] = '00'
  let [anotherHour, anotherMinute] = '00'
  if(state.childParam.dataObject.affiliation === '0') {
    [hour, minute] = currentOfficeData[`service_${type}_time`].split(":")
    if(type === 'start') [anotherHour, anotherMinute] = state.officeData['service_end_time'].split(":")
    if(type === 'end') [anotherHour, anotherMinute] = state.officeData['service_start_time'].split(":")
  } else if(state.childParam.dataObject.affiliation === '1') {
    [hour, minute] = currentOfficeData[`jihatsu_service_${type}_time`].split(":")
    if(type === 'start') [anotherHour, anotherMinute] = state.officeData['jihatsu_service_end_time'].split(":")
    if(type === 'end') [anotherHour, anotherMinute] = state.officeData['jihatsu_service_start_time'].split(":")
  }


  const totalMinutes = Number(hour) * 60 + Number(minute)
  const totalAnotherMinutes = Number(anotherHour) * 60 + Number(anotherMinute)
  state.attendanceTimeArray.forEach(el => {
    const currentMinutes = Number(el[`${type}Hour`]) * 60 + Number(el[`${type}Minute`])
    if(type === 'start' && (totalAnotherMinutes < currentMinutes || totalMinutes > currentMinutes)) {
      el[`${type}Hour`] = hour
      el[`${type}Minute`] = minute
    }
    if(type === 'end' && (totalAnotherMinutes > currentMinutes || totalMinutes < currentMinutes)) {
      el[`${type}Hour`] = hour
      el[`${type}Minute`] = minute
    }
    if(state.childParam.dataObject.affiliation === '' || state.childParam.dataObject.affiliation === '2' ) {
      el[`${type}Hour`] = '00'
      el[`${type}Minute`] = '00'
    }
  })

  return {hour: Number(hour), minute: Number(minute)}
}

export const handlePostDataAttendanceTimeValid = (
  state: any,
) => {
  // 来る時間帰る時間
  try {
    state.attendanceTimeArray.forEach((el: {[key: string]: string}, index: number) => {
      if (state.attendanceArray.indexOf(index + 1) !== -1) {
        // 帰る時間が来る時間より早くなっていないか
        const comeMinutes = Number(el.startHour) * 60 + Number(el.startMinute)
        const returnMinutes = Number(el.endHour) * 60 + Number(el.endMinute)
        if (comeMinutes > returnMinutes) {
          alert('利用曜日の利用時間が、来る時間よりも帰る時間が早くなっています。')
          throw new Error('バリデーションエラー')
        }
      }
      state.childParam.dataObject.attendanceTime[index][String(index + 1)] = {
        'start_time': `${el.startHour}:${el.startMinute}`,
        'end_time': `${el.endHour}:${el.endMinute}`
      }
    })
    return true
  } catch (error) {
    return false
  }
}
